import { render, staticRenderFns } from "./PointBitcashStore.vue?vue&type=template&id=6b91a85b"
import script from "./PointBitcashStore.vue?vue&type=script&lang=js"
export * from "./PointBitcashStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports